import numeral from 'numeral'

export default (ctx, inject) => {
  ctx.$numeral = numeral
  inject('numeral', numeral)
}
